import {
  RELATED_CONTENT_REQUEST,
  RELATED_CONTENT_RECEIVE,
  RELATED_CONTENT_FAILURE,
} from '../action-types';

export const fetchRelatedContentData = (clubId, messageId) => async (dispatch) => {
  try {
    dispatch({ type: RELATED_CONTENT_REQUEST, payload: { clubId, messageId } });
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `v2/club-website/${clubId}/related-content/${messageId}`,
    );
    const { data } = await response.json();

    dispatch({
      type: RELATED_CONTENT_RECEIVE,
      payload: { clubId, messageId, data },
    });

    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({ type: RELATED_CONTENT_FAILURE, payload: { clubId, messageId, statusCode, error } });
    return { error };
  }
};
